<template>
  <div class="drawer">
    <el-drawer
        size="700px"
        title="入库详情"
        :visible.sync="drawerStatus"
        @close="handleClose"
    >
      <div style="line-height: 44px">
        <el-row
            style="font-size: 12px; color: #333; border-bottom: 1px solid #f2f2f2"
        >
          <el-col :span="8">
            <span class="label">入库单号：</span>
            <span class="value">
              {{ detail.no }}
            </span>
          </el-col>
          <el-col :span="8">
            <span class="label">入库员：</span>
            <span class="value">
              {{inUser}}
            </span>
          </el-col>
          <el-col :span="8">
            <span class="label">入库日期：</span>
            <span class="value">
              {{ detail.inTime }}
            </span>
          </el-col>
        </el-row>
        <el-row
            style="font-size: 12px; color: #333; border-bottom: 1px solid #f2f2f2"
        >
          <el-col :span="8">
            <span class="label">入库类型：</span>
            <span class="value">
              {{   inOrderType}}
            </span>
          </el-col>
          <el-col :span="8">
            <span class="label">来源门店：</span>
            <span class="value">
              {{ detail.otherShopName }}
            </span>
          </el-col>
          <el-col :span="8">
            <span class="label">订单状态：</span>
            <span class="value">
              <el-link  type="danger" v-if="detail.status == 0">取消</el-link>
               <el-link v-if="detail.status == 1"> 正常</el-link>
            </span>
          </el-col>
        </el-row>
        <el-row
            style="font-size: 12px; color: #333; border-bottom: 1px solid #f2f2f2"
        >
          <el-col :span="8">
            <span class="label">验收状态：</span>
            <span class="value">
              <span v-if="detail.orderAcceptStatus == 0">未验收</span>
              <span v-if="detail.orderAcceptStatus == 1">部分验收</span>
              <span v-if="detail.orderAcceptStatus == 2">验收完成</span>
            </span>
          </el-col>
          <el-col :span="16">
            <span class="label">备注：</span>
            <span class="value">
              {{ detail.remark }}
            </span>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table :data="tableData" style="max-height:800px;overflow-y: scroll;margin-left:30px;margin-top:10px;">

          <el-table-column label="名称">
            <template slot-scope="props">
              {{ props.row.productName }}
            </template>
          </el-table-column>
          <el-table-column label="规格">
            <template slot-scope="props">
              <span>{{ props.row.skuName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="60">
            <template slot-scope="props">
              <span>{{ props.row.systemInspectiontUnit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数量" width="60">
            <template slot-scope="props">
              {{ props.row.shopInspectiontCount }}
            </template>
          </el-table-column>
          <el-table-column
              label="状态"
              v-if="detail.inOrderType && (detail.inOrderType.value == '0' || detail.inOrderType.value == '2')"
          >
            <template slot-scope="props">
              <span v-if="props.row.shopInspectiontCount == props.row.systemInspectiontCount">
                <span style="color: #13ce66">•</span>
                已验收 {{ props.row.shopInspectiontCount }} / {{ props.row.systemInspectiontCount }}
              </span>
              <span
                  v-if="
                  props.row.systemInspectiontCount > props.row.shopInspectiontCount &&
                  props.row.shopInspectiontCount != 0
                "
              >
                <span style="color: #e6a23c">•</span>
                部分验收 {{ props.row.shopInspectiontCount }} / {{ props.row.systemInspectiontCount }}
              </span>
              <span v-if="props.row.shopInspectiontCount == 0">
                <span style="color: #e6a23c">•</span>
                未验收 {{ props.row.shopInspectiontCount }} / {{ props.row.systemInspectiontCount }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawerStatus: false,
      detail: {},
      tableData: [],
      inUser:"",
      inOrderType:""
    };
  },
  props: {
    id: {
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
      this.getDetail();
    });
  },
  methods: {
    handleClose() {
      this.$emit("submit");
    },
    // 提交
    getDetail() {
      let params = {
        inorderId: this.id,
      };
      let loading = this.$loading();
      this.$http
          .get(process.env.VUE_APP_Url66 + "api/in/info", params)
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              this.detail = res.data;
              this.tableData = this.detail.orderItems;
              if(this.detail)
              {
                this.inUser=this.detail.inUser.title
                this.inOrderType=this.detail.inOrderType.title
              }
              console.log(this.tableData, "this.tableData");
            }
          });
    },

  },
};
</script>

<style scoped lang="scss">
.drawer {
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .label {
      display: inline-block;
      width: 100px;
      text-align: right;
      flex-shrink: 0;
      line-height: 24px;
    }
    .value {
      line-height: 24px;
    }
  }
}
</style>
